import ContentfulClient from "lib/ContentfulClient";

export const fetchGlobalSettings = () => ({
  type: "FETCH_GLOBAL_SETTINGS",
  payload: ContentfulClient.fetchGlobalSettings()
});
